// Add class when window is loaded
  //$(window).on("load", function() {
    // function addHighlightClass() {
    //   $(".new-varients").eq(0).addClass("flavor-slider");
    //   console.log("Class added to .new-varients");
    // }

    // addHighlightClass(); // Call the function to add the class after window is loaded
  //});

$(document).ready(function() {

//  function addHighlightClass() {
 //     $(".new-varients").eq(0).addClass("flavor-slider");
//     console.log("Class added to .new-varients");
   // }

    ///addHighlightClass(); // Call the function to add the class after window is loaded

  
// Move slick initialization inside the document ready function
 // function loadSelect() { 
 //  $('.flavor-slider .new-varients-inner').slick({
 //    dots: false,
 //    infinite: true,
 //    autoplay: false,
 //    speed: 200,
 //    slidesToShow: 4,
 //    arrows: false,
 //    slidesToScroll: 1,
 //    responsive: [
 //      {
 //        breakpoint: 1024,
 //        settings: {
 //          slidesToShow: 2,
 //          slidesToScroll: 2,
        
 //        }
 //      },
 //      {
 //        breakpoint: 600,
 //        settings: {
 //          slidesToShow: 2.3,
 //          slidesToScroll: 1
 //        }
 //      }
 //    ]
 //  });
 // }
 //  setTimeout(function() {
 //        loadSelect()
 //    }, 20);



 $('.product-recommend-mobile ul').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});



$('.testimonial-slider').slick({
  dots: false,
  infinite: false,
  autoplay: false,
  speed: 300,
  slidesToShow: 3,
  arrows:false,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
   
    {
      breakpoint: 600,
      settings: {
        slidesToShow:1,
        slidesToScroll: 1,
     
      }
    }
  ]
}); 



$('.homepage-flex-img').slick({
  dots: false,
  infinite: true,
  autoplay: false,
  speed: 300,
  slidesToShow: 8,
  arrows:false,
    slidesToScroll: 1,
  rows: 1,
  swipeToSlide: true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
   
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
     
      }
    }
  ]
}); 




$('.top-birthday-gifts-inner').slick({
  dots: false,
  infinite: false,
  autoplay: false,
  speed: 300,
  slidesToShow: 8,
  arrows:false,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
   
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3.6,
        slidesToScroll: 1,
     
      }
    }
  ]
}); 



$('.birthday-specialinner').slick({
  dots: false,
  infinite: false,
  autoplay: false,
  speed: 300,
  slidesToShow: 8,
  arrows:false,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: false,
      
      }
    },
   
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3.2,
        slidesToScroll: 1,
    
      }
    }
  ]
}); 




$('.birthday-surpises-in-right-slide').slick({
  dots: false,
  infinite: false,
  autoplay: false,
  speed: 300,
  slidesToShow: 4,
  arrows:true,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
   
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
          arrows:false,
      }
    }
  ]
}); 



$('.circle-slider-slide').slick({
  dots: false,
  infinite: true,
  autoplay: false,
  autoplaySpeed:1000,
  speed: 300,
  slidesToShow: 9.3,
  arrows:true,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1600,
      settings: {
        slidesToShow: 8.6,
        slidesToScroll: 1,
      
      }
    },
   
    {
      breakpoint: 1360,
      settings: {
        slidesToShow: 7.6,
        slidesToScroll: 1,
        
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        
      }
    }
  ]
}); 



$('.personality_pick_card_area').slick({
  dots: false,
  infinite: true,
  autoplaySpeed:1000,
  autoplay: false,
  speed: 300,
  slidesToShow: 4.4,
  arrows:true,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
   
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      }
    }
  ]
}); 



            $('.giftawesome_card_area').slick({
                dots: false,
                arrows: false,
                infinite: false,
                autoplay: false,
                autoplaySpeed: 1000,
               
                slidesToShow: 4,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1.5
                        }
                    }
                ]
            });
     


            $('.giftawesome_card_area').slick({
                dots: false,
                arrows: false,
                infinite: false,
                autoplay: false,
                autoplaySpeed: 1000,
               
                slidesToShow: 4,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });
 


           

        $('.street_area').slick({
            dots: false,
            arrows: true,
            infinite: true,
            autoplay: false,
            autoplaySpeed: 1000,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        dots: true,
                       arrows: false
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        dots: true,
                        arrows: false
                    }
                }
            ]
        });

        

            $('.delight-card-area').slick({
                dots: false,
                arrows: false,
                infinite: false,
                autoplay: false,
                autoplaySpeed: 1000,
               
                slidesToShow: 4,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1.4,
                          dots: true,
                        }
                    }
                ]
            });

    $('.occasion-slider').slick({
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 1000,
        slidesToShow: 4.3,
        slidesToScroll: 1,  // Scroll 0.3 slides each time to achieve a small scroll effect
        centerMode: true,     // Center mode to focus on the centered slide
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 0.2, // Adjust for smaller screens
                    centerMode: true
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1.4,
                    slidesToScroll: 0.1, // Adjust for even smaller screens
                    dots: true,
                    centerMode: true
                }
            }
        ]
    });

            $('.homepage-content').slick({
                dots: false,
                arrows: false,
                infinite: false,
                autoplay: false,
                autoplaySpeed: 1000,
               
                slidesToShow: 4,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                          dots: true,
                        }
                    }
                ]
            });

$(document).ready(function(){
  $('.collection-maindivision').slick({
     dots: false,
     slidesToShow: 14,
     infinite: true,
     slidesToScroll: 0,
     cssEase: 'linear',
     autoplay: false,
     autoplaySpeed: 600,
     rows: 1,
     swipeToSlide: true,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 10,
          
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
          
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3.5,
          
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 3.5,
          
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3.5,
          
        }
      }
    ]
  });
});


            $('.celebrating_card_area').slick({
                dots: false,
                arrows: false,
                infinite: false,
                autoplay: false,
                autoplaySpeed: 1000,
               
                slidesToShow: 4,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                          dots: true,
                        }
                    }
                ]
            });

            $('.first-best').slick({
                dots: false,
                arrows: false,
                infinite: false,
                autoplay: false,
                autoplaySpeed: 1000,
               
                slidesToShow: 2,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                          dots: true,
                        }
                    }
                ]
            });
    


            $('.bestsellers_card_area').slick({
                dots: false,
                arrows: true,
                infinite: false,
                autoplay: false,
                autoplaySpeed: 2000,
               
                slidesToShow: 4,
                slidesToScroll: 1,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1.2,
                             dots: true,
                           arrows: false,
                        }
                    }
                ]
            });
});













